import { RESOURCES_STRINGS } from '../constants/resources-strings';

export interface ResourceCountChipProps {
  count: number;
}

/**
 * Resource count as a legible pill ("1 resource" / "N resources"), used on the
 * folder tile and above the folder page's list (FR-155). The text is its own
 * accessible name. White fill so it reads on both a cover image and the page.
 */
export function ResourceCountChip({ count }: ResourceCountChipProps) {
  return (
    <span className="inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-white px-3 py-1 text-sm font-semibold text-navy shadow-card-soft">
      {RESOURCES_STRINGS.FOLDER_ITEM_COUNT(count)}
    </span>
  );
}
